import flattenDeep from 'lodash-es/flattenDeep';
import {makeApiCall} from '../lib/api/helpers';
import {sortListByKey} from '../lib/misc';
import {
  getCivilStatusApi,
  getAccountStatementDeliveryModeApi,
  getMarketingContactMethodsApi,
  getEducationApi,
  getEmploymentStatusesApi,
  getInstallmentsApi,
  getOccupationApi,
  getOfferAllDocumentsApi,
  getPropertyStatusApi,
  getFundingSourceApi,
  getRegionsApi,
  getCitiesApi,
  getPostalCodesApi,
  postFileApi,
  getFileApi,
  postLendingRequestAmlFingerprintApi,
  sendEmailMobileApi,
  sendEmailNotificationApi,
  esignInitApi,
  esignAuthCodeApi,
  esignResendAuthCodeApi,
  esignPostAuthApi,
  postCheckValidatedEmailApi,
  postValidateEmailApi,
  postValidateEmailCodeApi,
  getAddressTypeApi,
  postEstimatedOffersApi,
} from '../lib/api';

export const GET_ACTIVITIES = 'request/GET_ACTIVITIES';
export const GET_OFFER_DOCUMENT = 'request/GET_OFFER_DOCUMENT';
export const GET_CIVIL_STATUS = 'request/GET_CIVIL_STATUS';
export const GET_CONTACT_METHODS = 'request/GET_CONTACT_METHODS';
export const GET_ACCOUNT_STATEMENT_DELIVERY_MODE =
  'request/GET_ACCOUNT_STATEMENT_DELIVERY_MODE';
export const GET_MARKETING_CONTACT_METHODS =
  'request/GET_MARKETING_CONTACT_METHODS';
export const GET_EDUCATION = 'request/GET_EDUCATION';
export const GET_EMPLOYMENT_STATUSES = 'request/GET_EMPLOYMENT_STATUSES';
export const GET_DISMISS_LENDING_REASONS =
  'request/GET_DISMISS_LENDING_REASONS';
export const GET_LENDING_REQUEST_ASSIGNABLE_USERS =
  'request/GET_LENDING_REQUEST_ASSIGNABLE_USERS';
export const GET_OCCUPATION = 'request/GET_OCCUPATION';
export const GET_INSTALLMENTS = 'request/GET_INSTALLMENTS';
export const GET_PRODUCT_CATEGORIES = 'request/GET_PRODUCT_CATEGORIES';
export const GET_PROPERTY_STATUS = 'request/GET_PROPERTY_STATUS';
export const GET_FUNDING_SOURCE = 'request/GET_FUNDING_SOURCE';
export const GET_REGIONS = 'request/GET_REGIONS';
export const GET_CITIES = 'request/GET_CITIES';
export const GET_POSTAL_CODES = 'request/GET_POSTAL_CODES';
export const POST_FILE = 'request/POST_FILE';
export const GET_FILE = 'request/GET_FILE';
export let POST_LENDING_REQUEST_AML_FINGERPRINT =
  'request/POST_LENDING_REQUEST_AML_FINGERPRINT';
export const SEND_EMAIL_NOTIFY = 'request/SEND_EMAIL_NOTIFY';
export const ESIGN_INIT = 'request/ESIGN_INIT';
export const ESIGN_AUTH_CODE = 'request/ESIGN_AUTH_CODE';
export const ESIGN_RESEND_AUTH_CODE = 'request/ESIGN_RESEND_AUTH_CODE';
export const ESIGN_POST_AUTH = 'request/ESIGN_POST_AUTH';
export const CHECK_VALIDATED_CONTACT = 'request/CHECK_VALIDATED_CONTACT';
export const VALIDATE_CONTACT = 'request/VALIDATE_CONTACT';
export const VALIDATE_CODE = 'request/VALIDATE_CODE';
export const GET_ADDRESS_TYPE = 'request/GET_ADDRESS_TYPE';
export const POST_ESTIMATED_OFFERS = 'request/POST_ESTIMATED_OFFERS';

export const postLendingRequestAmlFingerprint =
  (payload, uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: POST_LENDING_REQUEST_AML_FINGERPRINT,
      dispatch,
      getState,
      alert: false,
      apiCall: postLendingRequestAmlFingerprintApi,
      apiArgs: [payload, uuid],
    });
  };

export const postFile = (payload, uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: POST_FILE,
    dispatch,
    getState,
    apiCall: postFileApi,
    apiArgs: [payload, uuid],
    formatResponse: response => response.data.data,
  });
};

export const getFile = (type, uuid, refId) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_FILE,
    dispatch,
    getState,
    apiCall: getFileApi,
    apiArgs: [type, uuid, refId],
    formatResponse: response => response.data.data,
  });
};

export const getOfferAllDocuments =
  (offerId, uuid, payload) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_OFFER_DOCUMENT,
      dispatch,
      getState,
      apiCall: getOfferAllDocumentsApi,
      apiArgs: [offerId, uuid, payload],
    });
  };

export const getRegions = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_REGIONS,
    dispatch,
    getState,
    apiCall: getRegionsApi,
    apiArgs: [uuid],
    formatResponse: response => response.data.data,
  });
};

export const getCities = (regionId, uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_CITIES,
    dispatch,
    getState,
    apiCall: getCitiesApi,
    apiArgs: [regionId, uuid],
    formatResponse: response => {
      return {
        [regionId]: sortListByKey(response.data.data),
      };
    },
  });
};

export const getPostalCodes =
  (localityId, uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_POSTAL_CODES,
      dispatch,
      getState,
      apiCall: getPostalCodesApi,
      apiArgs: [localityId, uuid],
      formatResponse: response => ({
        [localityId]: flattenDeep(response.data.data),
      }),
    });
  };

export const getOccupation = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_OCCUPATION,
    dispatch,
    getState,
    apiCall: getOccupationApi,
    apiArgs: [uuid],
    formatResponse: response => response.data.data,
  });
};

export const getInstallments =
  (locationId, uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_INSTALLMENTS,
      dispatch,
      getState,
      apiCall: getInstallmentsApi,
      apiArgs: [locationId, uuid],
      formatResponse: response => response.data.data,
    });
  };

export const getCivilStatus = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_CIVIL_STATUS,
    dispatch,
    getState,
    apiCall: getCivilStatusApi,
    apiArgs: [uuid],
    formatResponse: response => response.data.data,
  });
};

export const getEducation = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_EDUCATION,
    dispatch,
    getState,
    apiCall: getEducationApi,
    apiArgs: [uuid],
    formatResponse: response => response.data.data,
  });
};

export const getPropertyStatus = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_PROPERTY_STATUS,
    dispatch,
    getState,
    apiCall: getPropertyStatusApi,
    apiArgs: [uuid],
    formatResponse: response => response.data.data,
  });
};

export const getFundingSource = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_FUNDING_SOURCE,
    dispatch,
    getState,
    apiCall: getFundingSourceApi,
    apiArgs: [uuid],
    formatResponse: response => response.data.data,
  });
};

export const getEmploymentStatuses = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_EMPLOYMENT_STATUSES,
    dispatch,
    getState,
    apiCall: getEmploymentStatusesApi,
    apiArgs: [uuid],
    formatResponse: response => response.data.data,
  });
};

export const getAccountStatementDeliveryMode =
  uuid => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_ACCOUNT_STATEMENT_DELIVERY_MODE,
      dispatch,
      getState,
      apiCall: getAccountStatementDeliveryModeApi,
      apiArgs: [uuid],
      formatResponse: response => response.data.data,
    });
  };

export const getMarketingContactMethods =
  uuid => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_MARKETING_CONTACT_METHODS,
      dispatch,
      getState,
      apiCall: getMarketingContactMethodsApi,
      apiArgs: [uuid],
      formatResponse: response => response.data.data,
    });
  };

export const sendEmailMobile = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: SEND_EMAIL_NOTIFY,
    dispatch,
    getState,
    apiCall: sendEmailMobileApi,
    apiArgs: [uuid],
  });
};

export const sendEmailNotification =
  requestId => async (dispatch, getState) => {
    return makeApiCall({
      action: SEND_EMAIL_NOTIFY,
      dispatch,
      getState,
      apiCall: sendEmailNotificationApi,
      apiArgs: [requestId],
    });
  };

export const esignInit = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: ESIGN_INIT,
    dispatch,
    getState,
    alert: false,
    spinner: true,
    apiCall: esignInitApi,
    apiArgs: [uuid],
    formatResponse: response => response.data,
  });
};

export const esignAuthCode = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: ESIGN_AUTH_CODE,
    dispatch,
    getState,
    alert: false,
    spinner: true,
    apiCall: esignAuthCodeApi,
    apiArgs: [uuid],
    formatResponse: response => response.data,
  });
};

export const esignResendAuthCode = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: ESIGN_RESEND_AUTH_CODE,
    dispatch,
    getState,
    alert: false,
    spinner: true,
    apiCall: esignResendAuthCodeApi,
    apiArgs: [uuid],
    formatResponse: response => response.data,
  });
};
export const esignPostAuth = (uuid, code) => async (dispatch, getState) => {
  return makeApiCall({
    action: ESIGN_POST_AUTH,
    dispatch,
    getState,
    alert: false,
    spinner: true,
    apiCall: esignPostAuthApi,
    apiArgs: [uuid, code],
    formatResponse: response => response.data,
  });
};

export const postCheckValidatedEmail =
  (uuid, payload) => async (dispatch, getState) => {
    return makeApiCall({
      action: CHECK_VALIDATED_CONTACT,
      dispatch,
      getState,
      alert: false,
      apiCall: postCheckValidatedEmailApi,
      apiArgs: [uuid, payload],
    });
  };

export const postValidateEmail =
  (uuid, payload) => async (dispatch, getState) => {
    return makeApiCall({
      action: VALIDATE_CONTACT,
      dispatch,
      getState,
      alert: false,
      apiCall: postValidateEmailApi,
      apiArgs: [uuid, payload],
      formatResponse: response => response,
    });
  };

export const postValidateEmailCode =
  (uuid, payload) => async (dispatch, getState) => {
    return makeApiCall({
      action: VALIDATE_CODE,
      dispatch,
      getState,
      alert: false,
      apiCall: postValidateEmailCodeApi,
      apiArgs: [uuid, payload],
      formatResponse: response => response.status,
    });
  };

export const getAddressType = uuid => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_ADDRESS_TYPE,
    dispatch,
    getState,
    apiCall: getAddressTypeApi,
    apiArgs: [uuid],
    formatResponse: response => response.data.data,
  });
};

export const postEstimatedOffers =
  (uuid, payload) => async (dispatch, getState) => {
    return makeApiCall({
      action: POST_ESTIMATED_OFFERS,
      dispatch,
      getState,
      apiCall: postEstimatedOffersApi,
      apiArgs: [uuid, payload],
      formatResponse: response => response.data.data,
    });
  };

const initialState = {
  regions: null,
  cities: {},
  postalCodes: null,
  addressType: null,
  productCategories: null,
  occupation: null,
  civilStatus: null,
  education: null,
  propertyStatus: null,
  fundingSource: null,
  dismissLendingReasons: null,
  employmentStatuses: null,
  activities: null,
  assignableUsers: null,
  contactMethods: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${GET_REGIONS}_SUCCESS`:
      return {...state, regions: action.payload};

    case `${GET_CITIES}_SUCCESS`: {
      return {
        ...state,
        cities: {
          ...state.cities,
          ...action.payload,
        },
      };
    }
    case `${GET_POSTAL_CODES}_SUCCESS`: {
      return {
        ...state,
        postalCodes: {
          ...state.postalCodes,
          ...action.payload,
        },
      };
    }

    case `${GET_LENDING_REQUEST_ASSIGNABLE_USERS}_SUCCESS`:
      return {...state, assignableUsers: action.payload};
    case `${GET_PRODUCT_CATEGORIES}_SUCCESS`:
      return {...state, productCategories: action.payload};
    case `${GET_OCCUPATION}_SUCCESS`:
      return {...state, occupation: action.payload};
    case `${GET_CIVIL_STATUS}_SUCCESS`:
      return {...state, civilStatus: action.payload};
    case `${GET_EDUCATION}_SUCCESS`:
      return {...state, education: action.payload};
    case `${GET_PROPERTY_STATUS}_SUCCESS`:
      return {...state, propertyStatus: action.payload};
    case `${GET_FUNDING_SOURCE}_SUCCESS`:
      return {...state, fundingSource: action.payload};
    case `${GET_DISMISS_LENDING_REASONS}_SUCCESS`:
      return {...state, dismissLendingReasons: action.payload};
    case `${GET_EMPLOYMENT_STATUSES}_SUCCESS`:
      return {...state, employmentStatuses: action.payload};
    case `${GET_ACTIVITIES}_SUCCESS`:
      return {
        ...state,
        activities: {
          ...state.activities,
          [`${action.args[0]}`]: action.payload,
        },
      };
    case `${GET_CONTACT_METHODS}_SUCCESS`:
      return {...state, contactMethods: action.payload};
    case `${GET_ACCOUNT_STATEMENT_DELIVERY_MODE}_SUCCESS`:
      return {...state, accountStatementDeliveryMode: action.payload};
    case `${GET_MARKETING_CONTACT_METHODS}_SUCCESS`:
      return {...state, marketingContactMethods: action.payload};
    case `${GET_ADDRESS_TYPE}_SUCCESS`:
      return {...state, addressType: action.payload};
    default:
      return state;
  }
};
